import React, { useRef, useEffect, useState } from 'react'
import { useUpdateEffect } from 'react-use'
import dynamic from 'next/dynamic'
import produce from 'immer'
import { Droppable } from 'react-beautiful-dnd'
import { RiAddFill } from 'react-icons/ri'
import Classnames from 'classnames'

import { motion, AnimatePresence } from 'framer-motion'
import ClickAwayListener from 'react-click-away-listener'

import styled from '@emotion/styled'

import ContentEditable from 'react-contenteditable'
import TextareaAutosize from 'react-textarea-autosize'

import { useRecoilState, useRecoilValue, useRecoilCallback } from 'recoil'
import { content, content_block } from '@/store/template/content'
import {
  showListDetailModal,
  detailModalContentID,
} from '@/store/onepager/onepager'
import { isBuilder } from '@/store/builder/store'
import {
  undoHistoryAction,
  undoHistoryActionCount,
} from '@/store/builder/history'

// components
import Title from '@/components/onepager/sections/Title'
import Task from '@/components/onepager/sections/_tasks/Task'
import DetailModal from '@/components/onepager/lists/DetailModal'
import ItemAdd from '@/components/onepager/lists/ItemAdd'

function Tasks({ id, contentID, sectionData, wrapperId }) {
  const [getContent, setContent] = useRecoilState(content(contentID))
  const showDetailModal = useRecoilValue(showListDetailModal)
  const [focusTask, setFocusTask] = useState(-1)
  const [focusTaskInline, setFocusTaskInline] = useState(-1)
  const [newTaskContent, setNewTaskContent] = useState('')
  const [addedNewTask, setAddedNewTask] = useState(false)
  const [showAddTaskInline, setShowAddTaskInline] = useState(false)
  const isBuilderApp = useRecoilValue(isBuilder)
  const [isEditableOnly, setEditableOnly] = useState(true)

  const newItemEditor = React.createRef()
  const ceNewTask = React.useRef()
  const contentEditable = React.createRef()
  // const newTaskText = useRef('');

  const [newTaskText, setNewTaskText] = useState('')

  const [getHistoryAction, setHistoryAction] = useRecoilState(undoHistoryAction)
  const [getHistoryActionCount, setHistoryActionCount] = useRecoilState(
    undoHistoryActionCount
  )

  // undoSystem -- Content System
  useUpdateEffect(async () => {
    if (isBuilderApp) {
      if (!getHistoryAction) {
        setHistoryActionCount(getHistoryActionCount + 1)
      } else {
        setHistoryAction(false)
      }
    }
  }, [getContent])

  useEffect(() => {
    if (isBuilderApp) {
      // in builder
    } else {
      if (sectionData.data.readonly == 'true') {
        setEditableOnly(false)
      }
    }
  }, [])

  // useEffect(() => {
  //   if (showAddTaskInline) {
  //     console.log(showAddTaskInline)
  //     ceNewTask.current.focus()
  //   }
  // }, [showAddTaskInline])

  useEffect(() => {
    // anytime a item is added
    setNewTaskContent('')
  }, [getContent])

  const NewTaskDiv = styled.div`
    outline: none;
    border-radius: 3px;
    font-weight: 500;
    padding: 12px 15px;
    background: #fff !important;
    border: 1px solid #71809680;
    box-shadow: inset 0 0 0 3px #71809610, 0 1px 3px 0 rgba(0, 0, 0, 0.08),
      0 1px 2px 0 rgba(0, 0, 0, 0.06);
    background-color: #a0aec005;
    color: #2b2f35;
    font-size: 16px;
  `

  const newTaskOnEnter = e => {
    if (e.key === 'Enter') {
      e.preventDefault()
      addTaskOnClick()
    }
  }

  const newTaskTextChange = evt => {
    // newTaskText.current = evt.target.value;
    setNewTaskContent(evt.target.value)
  }

  const addTaskOnClick = () => {
    const newTask = {
      text: newTaskContent,
      desc: '',
      color: 'default',
      complete: false,
      notes: '',
    }

    const taskId = guidGenerator()

    // push ID to this getContent.blocks
    const nextState = produce(getContent, draft => {
      draft.blocks.push(taskId)
    })

    setContent(nextState)

    insertContentBlock(taskId, newTask)

    // setNewTaskContent('')

    // setShowAddTaskInline(false)

    // setAddedNewTask(getContent.blocks.length - 1)
  }

  const insertContentBlock = useRecoilCallback(
    ({ set, newId, newContent }) => {
      return (newId, newContent) => {
        // set and create content
        set(content_block(newId), newContent)
      }
    },
    [content_block]
  )

  function guidGenerator() {
    var S4 = function () {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
    }
    return (
      S4() +
      S4() +
      '-' +
      S4() +
      '-' +
      S4() +
      '-' +
      S4() +
      '-' +
      S4() +
      S4() +
      S4()
    )
  }

  function clickawayCheck() {
    if (newTaskContent) {
      addTaskOnClick()
    }

    setShowAddTaskInline(false)
    setNewTaskContent('')
  }

  return (
    <div>
      {/* LIST ITEM DETAIL VIEW */}
      {/* <AnimatePresence exitBeforeEnter>
        {showDetailModal && <DetailModal />}
      </AnimatePresence> */}

      <Droppable key={id} droppableId={id} type="TASKS">
        {(provided, snapshot) => (
          <div key={id} ref={provided.innerRef} {...provided.droppableProps}>
            <Title
              id={id}
              title={sectionData.title}
              prompt={sectionData.prompt}
              wrapperId={wrapperId}
            />

            <div className="boxBody">
              <div className="">
                {getContent.blocks.map((task, index) => (
                  <div key={task}>
                    <Task
                      id={task}
                      contentID={contentID}
                      index={index}
                      focused={focusTask == index}
                      sectionData={sectionData}
                    />
                  </div>
                ))}
              </div>

              {/* ref={el => tasksRef.current[index] = el} */}
              {/*  onInlineAdd={(setInd) => {
                  setFocusTaskInline(setInd)
                  setAddedNewTask(setInd)
                }} */}

              {provided.placeholder}

              {isEditableOnly && (
                <AnimatePresence initial={false}>
                  {showAddTaskInline && (
                    <ItemAdd
                      ref={newItemEditor}
                      newTaskContent={newTaskContent}
                      newTaskOnEnter={newTaskOnEnter}
                      placeholder={sectionData.data.addbutton}
                      newTaskTextChange={newTaskTextChange}
                      hideButton={() => {
                        setShowAddTaskInline(false)
                      }}
                      clickAway={clickawayCheck}
                    />
                  )}

                  {!showAddTaskInline && (
                    <motion.button
                      onClick={() => {
                        setShowAddTaskInline(true)
                      }}
                      initial="hidden"
                      animate="visible"
                      exit="exit"
                      variants={{
                        hidden: {
                          opacity: 0,
                          scale: 0.95,
                        },
                        visible: {
                          opacity: 1,
                          scale: 1,
                        },
                        exit: {
                          opacity: 0,
                          scale: 0.95,
                        },
                      }}
                      className={Classnames(
                        'mt-0 addTaskBtn hover:text-white  px-1 py-1 pr-2 font-bold rounded flex items-center text-base',
                        {
                          addTaskBtnBig: getContent.blocks.length == 0,
                        }
                      )}
                    >
                      <div
                        className={Classnames('mr-1 text-lg', {
                          'text-2xl mr-2 taskBtnPlus rounded-full bg-gray-200 hover-group:bg-black hover-group:bg-opacity-10':
                            getContent.blocks.length == 0,
                        })}
                      >
                        <RiAddFill />
                      </div>
                      <div className="text-left flex items-baseline">
                        {sectionData.data.addbutton}
                      </div>
                    </motion.button>
                  )}
                </AnimatePresence>
              )}

              {/* {JSON.stringify(getContent)} */}
              {/* <span className="text-xs text-gray-700 mt-8">{id}</span> */}
            </div>
          </div>
        )}
      </Droppable>
    </div>
  )
}

export default Tasks
